import React, { Component } from 'react';
import styles from './ArenaOnboardingPage.scss';
import { Button, Text, Heading } from 'wix-style-react';
import cx from 'classnames';

class ArenaOnboardingPage extends Component {
  getDivider = () => {
    const { t } = this.props;
    return (
      <div className={styles.divider}>
        <div className={styles.line} />
        <div className={styles.or}>{t('LOGO_ON_BOARDING_SPLIT_HIRE_OR')}</div>
        <div className={styles.line} />
      </div>
    );
  };

  getContainer = (titleText, descriptionText, buttonText, onClick, dataHook) => {
    return (
      <div className={styles.halfPageContainer}>
        <div className={styles.title}>
          <Heading appearance="H1">
            <span className={styles.titleFont}>{titleText}</span>
          </Heading>
        </div>
        <div className={styles.subtitle}>
          <Text size="medium" weight="normal">
            <span className={styles.subtitleFont}>{descriptionText}</span>
          </Text>
        </div>
        <div className={styles.action}>
          <Button dataHook={dataHook} className={styles.link} size="large" onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    );
  };

  getDesignerContainer() {
    const { t, onGoToOnArena } = this.props;
    return this.getContainer(
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_TITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_SUBTITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_CTA'),
      onGoToOnArena,
      'designer-btn'
    );
  }

  getLogoContainer() {
    const { t, onGoToOnBoarding } = this.props;
    return this.getContainer(
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_TITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_SUBTITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_CTA'),
      onGoToOnBoarding,
      'logo-btn'
    );
  }

  render() {
    const { t } = this.props;

    const sides = [this.getLogoContainer(), this.getDesignerContainer()];
    return (
      <div className={styles.page}>
        <div className={styles.pageHeader}>
          <div className={styles.pageHeaderText}>
            <Text size="medium" weight="normal">
              {t('LOGO_ON_BOARDING_SPLIT_HIRE_HEADER')}
            </Text>
          </div>
        </div>

        <div className={styles.container}>
          <div className={cx(styles.split)}>
            {sides[0]}
            {this.getDivider()}
            {sides[1]}
          </div>
        </div>
      </div>
    );
  }
}

export default ArenaOnboardingPage;
